import React, { Component } from 'react'

import HeroMask from '../../Components/HeroMask'
import { HeroAside } from '../../Components/Aside'

class Hero extends Component {
  render() {
    const { content, openModal } = this.props
    return (
      <section id={'hero'}>
        <HeroVideo video={content.video} openModal={openModal} />
        <HeroAside content={content.main} />
      </section>
    )
  }
}

function HeroVideo({ video, openModal }) {
  return (
    <div id={'hero-video-container'}>
      <video autoPlay muted loop playsInline>
        <source
          src={video.src}
          type={'video/mp4'}
          width={window.innerWidth * 0.5}
          height={window.innerHeight}
        />
        {video.alt}
      </video>
      <HeroMask />
      {video.hidePlayBtn === true ? null : (
        <button id={'playVideo'} onClick={() => openModal()} />
      )}
    </div>
  )
}

export default Hero



// WEBPACK FOOTER //
// ./src/Views/Home/Hero.js